export default {
  disclaimer: {
    summary:
      'Houd er rekening mee dat het uw verantwoordelijkheid is om te bevestigen dat alle valuta en belastingen correct zijn voor de van toepassing zijnde jurisdictie.',
    extra:
      'Wij nemen deze informatie uitsluitend op voor uw gemak en aanvaarden geen verantwoordelijkheid voor de juistheid van de valuta en/of belastingen of voor de betaling van dergelijke belastingen als onderdeel van onze producten. De informatie die hier is opgenomen met betrekking tot valuta en belastingen is uitsluitend bedoeld voor informatieve doeleinden.',
    show_more: 'Meer weergeven',
    show_less: 'Minder weergeven',
  },
  partner_note:
    'Dit zijn uw standaardwaarden op partnerniveau. Restaurants onder uw account nemen deze waarden automatisch over, tenzij ze een categorie afzonderlijk overschrijven.',
  section_title: 'Belastingtarieven voor menu-items',
  new_category_placeholder: 'Nieuwe categorie',
  form: {
    name: {
      label: 'Belastingcategorie',
    },
    default_tax_rate: {
      label: 'Standaardtarief',
      tooltip:
        'Wordt gebruikt als terugvaloptie wanneer een specifiek tarief voor een bestelmethode hieronder leeg wordt gelaten.',
    },
    pickup_tax_rate: {
      label: 'Afhalen',
    },
    delivery_tax_rate: {
      label: 'Bezorging',
    },
    dine_in_tax_rate: {
      label: 'In restaurant',
    },
    on_site_tax_rate: {
      label: 'Tafelbestellen',
    },
    show_zero_tax_in_summary: {
      label: '0% belasting weergeven in besteloverzicht',
    },
  },
  buttons: {
    add_category: 'Nieuwe belastingcategorie toevoegen',
    cancel: 'Annuleren',
    save: 'Opslaan',
    confirm: 'Verwijderen',
    delete: 'Categorie verwijderen',
    reset: 'Terugzetten naar overgeërfd',
  },
  delete_confirm: {
    title: 'Deze belastingcategorie verwijderen?',
    description: 'Dit kan niet ongedaan worden gemaakt.',
  },
  scope_labels: {
    region: 'Regiobreed',
    partner: 'Partnerbreed',
    restaurant: 'Restaurantbreed',
  },
  confirm_modal: {
    title: {
      fork: 'Er een eigen categorie van dit restaurant van maken?',
      owned: 'Nieuwe tarieven toepassen?',
      reset: 'Teruggaan naar de overgeërfde categorie?',
    },
    affected_one: '{{count}} product of categorie is momenteel gekoppeld en krijgt de nieuwe tarieven.',
    affected_other: '{{count}} producten en categorieën zijn momenteel gekoppeld en krijgen de nieuwe tarieven.',
    affected_settings_one:
      '{{count}} product of categorie is momenteel gekoppeld en gebruikt de bijgewerkte instellingen.',
    affected_settings_other:
      '{{count}} producten en categorieën zijn momenteel gekoppeld en gebruiken de bijgewerkte instellingen.',
    restaurants_one: 'Dat is {{count}} restaurant.',
    restaurants_other: 'Dat zijn {{count}} restaurants.',
    acknowledge:
      'Ik begrijp dat het bevestigen hiervan de belastingcategorie wijzigt voor alle producten die momenteel aan deze categorie zijn gekoppeld',
    impact_error: 'Controleren welke producten dit zou wijzigen is mislukt',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
  },
  toasts: {
    load_error: 'Kan de belastingcategorieën niet laden.',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen zijn opgeslagen',
    delete_error: 'Kan deze belastingcategorie niet verwijderen.',
    category_deleted: 'Belastingcategorie verwijderd',
    category_reset: 'Belastingcategorie teruggezet naar de overgeërfde',
    reset_error: 'Kon deze belastingcategorie niet resetten.',
    impact_error: 'Controleren welke producten dit zou wijzigen is mislukt',
    impact_changed_one: 'Het aantal getroffen producten is gewijzigd naar {{count}}. Controleer en bevestig opnieuw.',
    impact_changed_other: 'Het aantal getroffen producten is gewijzigd naar {{count}}. Controleer en bevestig opnieuw.',
  },
};
